import React, { useState, useEffect } from "react";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import { useRecoilState } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import OfficeDivisionForm from "./OfficeDivisionForm";
import AddButton from "../../../../components/AddButton";

import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";

import useOfficeDivision from "./hooks/useOfficeDivision";
import useDeleteOfficeDivision from "./hooks/useDeleteOfficeDivision";
import useUpdateOfficeDivision from "./hooks/useUpdateOfficeDivision";
import {
  addStateOfficeDivision,
  selectedRowsStateOfficeDivision,
  setFilterTextOfficeDivision,
} from "./atoms/atoms";
import TableFilters from "../TableFilters";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import { useQueryClient } from "react-query";
import MaterialOfficeConfigTable from "../../../../components/tables/MaterialOfficeConfigTable";

const OfficeDivisionTable = () => {
  const { data, isFetching } = useOfficeDivision();
  const [OfficeDivisionFilteredData, setOfficeDivisionFilteredData] = useState(
    []
  );
  const { mutateAsync: UpdateOfficeDivision } = useUpdateOfficeDivision();
  const BulkDeleteOfficeDivision = useDeleteOfficeDivision();
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateOfficeDivision
  );
  const [filterText, setFilterText] = useRecoilState(
    setFilterTextOfficeDivision
  );
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateOfficeDivision
  );
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [, setDivisionIsExistState] = useState(false);
  const [divisionDataIsChange, setDivisionDataIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasOfficeDivision] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [hideColumn, sethideColumn] = useState(false);
  const [displayNote] = useState(false);
  const [edit, setEdit] = useState(false);
  const queryClient = useQueryClient();

  const addPermission = PERMISSIONS.permission_utilities_officedivision_add;
  const editPermission = PERMISSIONS.permission_utilities_officedivision_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_officedivision_delete;

  const userPermissions = useRecoilValue(permissionsSelector);
  const defaultValues = {
    divisionId: 0,
    divisionName: "",
    divisionCode: "",
    isActive: 0,
    updatedBy: "",
    updatedOn: null,
    createdOn: null,
    createdBy: "",
  };
  const [divisionNewData, setDivisionNewData] = useState([defaultValues]);
  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
  } else {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (divisionDataIsChange.data) {
      setOfficeDivisionFilteredData(divisionDataIsChange.data);
    }
  }, [divisionDataIsChange.data]);

  useEffect(() => {
    if (recordIdFromRecent !== "") {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setOfficeDivisionFilteredData(result);
          setOfficeDivId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    setDivisionIsExistState(false);
    setDivisionDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleCheckBox = (checked) => {
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? divisionNewData.map((x) => (x.isActive = true))
      : divisionNewData.map((x) => (x.isActive = false));

    const result = data.filter(
      (item) =>
        item.divisionName?.toUpperCase() ===
          divisionNewData[0].divisionName?.toUpperCase() &&
        item.isActive === checkStatus
    );

    if (result.length > 0 && result !== undefined) {
      setDivisionDataIsChange(true);
    } else {
      setDivisionDataIsChange(false);
    }
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, e) => {
    e = e.trim();

    if (SourceType?.toLowerCase() === "officedivisonname") {
      divisionNewData.map((x) => (x[fieldName] = e));
      const result = data.filter(
        (item) =>
          item.divisionName?.toUpperCase() ===
            divisionNewData[0].divisionName?.toUpperCase() &&
          item.isActive === checkStatus
      );

      if (result.length > 0 && result !== undefined) {
        setDivisionIsExistState(true);
        setDivisionDataIsChange(false);
      } else {
        setDivisionIsExistState(false);

        let reqFields = ["divisionName", "divisionCode"];
        if (
          reqFields.includes(fieldName) &&
          divisionNewData[0].divisionName &&
          divisionNewData[0].divisionCode &&
          e !== ""
        ) {
          setDivisionDataIsChange(true);
        } else if (
          fieldName === "divisionCode" &&
          divisionNewData[0].divisionCode
        ) {
          setDivisionDataIsChange(true);
        } else {
          setDivisionDataIsChange(false);
        }
      }
    }

    if (SourceType?.toLowerCase() === "officedivisoncode") {
      divisionNewData.map((x) => (x[fieldName] = e));
      const result = data.filter(
        (item) =>
          item.divisionCode?.toUpperCase() ===
            divisionNewData[0].divisionCode?.toUpperCase() &&
          item.isActive === checkStatus
      );

      if (result.length > 0 && result !== undefined) {
        setDivisionIsExistState(true);
        setDivisionDataIsChange(false);
      } else {
        setDivisionIsExistState(false);

        let reqFields = ["divisionName", "divisionCode"];
        if (
          reqFields.includes(fieldName) &&
          divisionNewData[0].divisionName &&
          divisionNewData[0].divisionCode &&
          e !== ""
        ) {
          setDivisionDataIsChange(true);
        } else if (
          fieldName === "divisionName" &&
          divisionNewData[0].divisionName
        ) {
          setDivisionDataIsChange(true);
        } else {
          setDivisionDataIsChange(false);
        }
      }
    }
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.divisionId);
    setDivisionDataIsChange(false);
    setEdit(true);
    setCheckStatus(rowData.isActive);
    divisionNewData.map((x) => (x.isActive = rowData.isActive));
    divisionNewData.map((x) => (x.divisionId = rowData.divisionId));
    divisionNewData.map((x) => (x.divisionName = rowData.divisionName));
    divisionNewData.map((x) => (x.divisionCode = rowData.divisionCode));
    divisionNewData.map((x) => (x.createdOn = rowData.createdOn));
    divisionNewData.map((x) => (x.createdBy = rowData.createdBy));
    divisionNewData.map((x) => (x.updatedOn = rowData.updatedOn));
    divisionNewData.map((x) => (x.updatedBy = rowData.updatedBy));
  };

  const handleSave = (divisionNewData) => {
    setOpenModalEdit(false);
    if (actionEditState) {
      UpdateOfficeDivision(divisionNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModalEdit(false);
          } else {
            setDivisionNewData([defaultValues]);
            setEditRowId([]);
            setSelectedRows([]);
            setOpenModalEdit(false);
            setActionEditState(false);
            setDisabledButton(false);
            sethideColumn(false);
            setEdit(false);
            setDivisionDataIsChange(false);
            queryClient.invalidateQueries(["GetOfficeDivision"]);
            toast.fire(
              "Success",
              "Office Division Updated Successfully",
              "success"
            );
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Update OfficeDivision", "error");
          queryClient.invalidateQueries(["GetOfficeDivision"]);
          setOpenModalEdit(false);
        },
      });
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setEditRowId([]);
      setOpenModalEdit(false);
      setDivisionDataIsChange(false);
      setActionEditState(false);
      setDisabledButton(false);
      setEdit(false);
    }
  };

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.divisionId);
    BulkDeleteOfficeDivision(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Office Divisions" : "Office Division"
    }?`}</div>
  );

  const matColumns = [
    {
      title: "Division Code",
      field: "divisionCode",
      customSort: (a, b) =>
        a.divisionCode && b.divisionCode
          ? a.divisionCode.trim().localeCompare(b.divisionCode.trim())
          : a.divisionCode
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.divisionId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Division Code"
              defaultValue={rowData.divisionCode}
              onChange={(e) => {
                handleEditFieldsChange(
                  "officedivisoncode",
                  "divisionCode",
                  rowData,
                  e.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.divisionCode}</>
        );
      },
    },
    {
      title: "Division Name",
      field: "divisionName",
      customSort: (a, b) =>
        a.divisionName && b.divisionName
          ? a.divisionName.trim().localeCompare(b.divisionName.trim())
          : a.divisionName
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.divisionId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Division Code"
              defaultValue={rowData.divisionName}
              onChange={(e) => {
                handleEditFieldsChange(
                  "officedivisonname",
                  "divisionName",
                  rowData,
                  e.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.divisionName}</>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.divisionId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdOn",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.divisionId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.createdOn
              ? new Date(rowData.createdOn).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified Date",
      field: "updatedOn",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.divisionId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.updatedOn
              ? new Date(rowData.updatedOn).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified By",
      field: "updatedBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.divisionId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.updatedBy}</>
        );
      },
    },

    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return rowData.divisionId === editRowId ? (
          <div className="flex justify-start space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },

    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.divisionId === editRowId ? (
          <div className="flex place-content-center whitespace-nowrap">
            <SaveButton
              className={`rounded-full  lg:text-center bg-senary hover:bg-senary
               ${
                 !hasOfficeDivision || !divisionDataIsChange
                   ? "opacity-50"
                   : "opactiy-100"
               }
             }`}
              disabled={!hasOfficeDivision || !divisionDataIsChange}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              className="flex text-xs shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditRowId([]);
                setDivisionDataIsChange(false);
                setDivisionIsExistState(false);
                setDisabledButton(false);
                sethideColumn(false);
                setEdit(false);
              }}
            />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                  : "opacity-100 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary"
              }
              onClick={() => {
                setDisabledButton(true);
                setActionEditState(true);
                handleEditButton(rowData);
                sethideColumn(true);
              }}
            />
          </div>
        );
      },
    },
  ];

  //Filters
  const [officeDivId, setOfficeDivId] = useState("");
  useEffect(() => {
    if (filterText) {
      setOfficeDivisionFilteredData(
        data?.filter((x) =>
          x.divisionCode
            ?.toLowerCase()
            .includes(filterText.trim()?.toLowerCase())
        )
      );
    } else if (officeDivId?.includes(".")) {
      let ids = officeDivId.split(".");
      const arr = ids.map((id) => Number(id));
      const filteredData = data?.filter((x) => arr.includes(x.divisionId));
      setOfficeDivisionFilteredData(filteredData);
    } else {
      const filteredData = data?.filter(
        (x) => x.divisionId === Number(officeDivId)
      );
      setOfficeDivisionFilteredData(filteredData);
    }
  }, [filterText, data]);

  return (
    <div className="animate-fade-in-down w-full ">
      {actionAddState ? (
        ""
      ) : (
        <div className="font-bold text-primary text-xl uppercase mx-4"> {}</div>
      )}
      {!actionAddState && (
        <>
          <div className="bg-white p-4 space-y-2">
            <div className="flex flex-row justify-between items-center ">
              <TableFilters
                filterText={setFilterText}
                moduleDetails="Division Code"
                textInputName="DivisionCode"
                disabledButton={disabledButton || selectedRows.length > 0}
              ></TableFilters>

              <div className="mr-1">
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    buttonText="New Division Name"
                    className={
                      selectedRows.length > 0 || actionEditState
                        ? "opacity-50"
                        : "opacity-100"
                    }
                    onClick={() => setActionAddState(!actionAddState)}
                    disabled={disabledButton || selectedRows.length > 0}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <div>
              {userPermissions.includes(deletePermission) ? (
                <div className="text-secondary italic text-xs3 my-2">
                  <p className="font-bold italic inline-block mr-1">Note:</p>
                  <span>Tick the box to deactivate some data.</span>
                </div>
              ) : (
                <div className="mb-4"></div>
              )}
            </div>
            <div className="">
              <MaterialOfficeConfigTable
                columns={matColumns}
                data={
                  OfficeDivisionFilteredData?.length > 0
                    ? OfficeDivisionFilteredData
                    : data
                    ? filterText === ""
                      ? data
                      : OfficeDivisionFilteredData
                    : []
                }
                options={{
                  toolbar: false,
                  showTitle: false,
                }}
                selection={
                  !actionEditState && userPermissions.includes(deletePermission)
                }
                setOpenModal={setOpenModalDelete}
                onSelectionChange={handleSelectedRowsChange}
                selectedRows={selectedRows}
                isDeactivate={true}
                isLoading={isFetching}
              />
            </div>
          </div>

          <ConfirmBoxModal
            ModalTitle="Update Division Name"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => {
              setOpenModalEdit(false);
              sethideColumn(true);
            }}
            onClickFunction={() => {
              handleSave(divisionNewData);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate Division Name"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />
        </>
      )}
      {actionAddState && (
        <div className="p-4">
          <OfficeDivisionForm />
        </div>
      )}
      {}
    </div>
  );
};

export default OfficeDivisionTable;
